/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-06-24 10:01:00
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-06-24 15:04:24
 * @FilePath: \new_typhoonmap\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'leaflet/dist/leaflet.css'
import ElementUI from 'element-ui';
import axios from "axios";
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
Vue.prototype.$axios = axios
// Vue.prototype.$url = '/devapi/SWDataservice/interface/v1/api'
Vue.prototype.$url = 'https://www.moodsmap.com/SWDataservice/interface/v1/api'
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
